export const ITEMS_PER_PAGE = 20;

export const EMAIL_VALIDATION_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

const insert = (arr, index, newItem) => [
  // part of the array before the specified index
  ...arr.slice(0, index),
  // inserted item
  newItem,
  // part of the array after the specified index
  ...arr.slice(index)
];

const deepCopy = obj => {
  return JSON.parse(JSON.stringify(obj));
}

export const notyfSuccess = (notyf, message) => {
  notyf.success({
    position: {x: 'right', y: 'top'},
    message: message,
    dismissible: true,
  });
};

export const notyfError = (notyf, message) => {
  notyf.error({
    position: {x: 'right', y: 'top'},
    message: message,
    dismissible: true,
  });
};

const getSelectedPage = (page, total) => {
  if(!page || Number.isNaN(page) || page > Math.ceil(total / ITEMS_PER_PAGE)) {
    return 1;
  }
  return page;
};

const formatNumber = (number, decimalPlaces) => {
  return (Math.round(number * 100) / 100).toFixed(decimalPlaces);
};

const utils = {
  ITEMS_PER_PAGE,
  insert,
  deepCopy,
  notyfSuccess,
  notyfError,
  getSelectedPage,
  formatNumber,
};
export default utils;